import { DatePipe } from "@angular/common";
import { FormControl, FormGroup } from "@angular/forms";
import { ClientModel } from "./client.model";
import { IssueModel, IssueTrackModel } from "./issue.model";
import { UserModel } from "./user.model";

export class CallModel {
    client : ClientModel;
    clientType: string;
    destination : string;
    callLog : CallLogModel;
    issue : IssueModel;
    issueTrack : IssueTrackModel;
    status : string;
    isLastStep : boolean;
    isEnd : boolean;
    createTime :  DatePipe;
    createBy : string;
}

export class CallLogModel {
    callId : string;
    clientId : string;
	clientType: string;
    destination : string;
    createTime :  DatePipe;
    status : string;
    endTime :  DatePipe;
    duration : number;
    issueId : string;
    note : string;
    createBy : string;


    public static getFormGroup()
    {
        var form = new FormGroup({
            callId: new FormControl(null),
            clientId: new FormControl(null),
            clientType: new FormControl('C'),
            destination : new FormControl('CA'),
            createTime :  new FormControl(null),
            status : new FormControl(null),
            endTime: new FormControl(null),
            duration: new FormControl(null),
            issueId: new FormControl(null),
            note: new FormControl(null),
            createBy: new FormControl(null),
        });

        return form;

    }

    public static initializeFormGroup(form){

        return form.setValue({
            callId: null,
            clientId: null,
            clientType: null,
            destination : null,
            createTime :  null,
            status : null,
            endTime: null,
            duration: 0,
            issueId: null,
            note: null,
            createBy: null
        });

    }

    public static populateForm(form, item : CallLogModel) {
        return form.setValue(item);
    }
}

export class CallDetailLogModel {
    callId : string;
    clientId : string;
	  clientType: string;
    destination : string;
    clientName : string;
    clientCompany : string;
    clientPhone1 : string;
    clientPhone2 : string;
    clientEmail1 : string;
    clientEmail2 : string;
    status : string;
    endTime :  DatePipe;
    duration : number;
    issueId : string;
    ticketNo : number;
    note : string;
    createTime :  DatePipe;
    createBy : string;
    createByUser : UserModel;

    public static  convertToCallModel(item : CallDetailLogModel)
    {
        var data = new CallLogModel();
        data.callId = item.callId;
        data.clientId = item.clientId;
        data.clientType= item.clientType;
        data.destination = item.destination;
        data.status = item.status;
        data.endTime = item.endTime;
        data.duration = item.duration;
        data.issueId = item.issueId;
        data.note = item.note;
        data.createTime = item.createTime;
        data.createBy = item.createBy;
        return data;
    }
}

export class CallLogCountModel {
    date : any;
    year: number;
    month : number;
    day :  number;
    count : number;
 }
